import { bl_rvm_cfp_program_hdr_RowClass } from '../../../dbschema/bl_rvm_cfp_program_hdr.model';
import { BaseContainerModel } from '../../base-container.model';

export class CfpProgramHdrContainerModel extends BaseContainerModel {
  bl_rvm_cfp_program_hdr: bl_rvm_cfp_program_hdr_RowClass = new bl_rvm_cfp_program_hdr_RowClass();
}
